<template>
  <section
    v-if="cardProfile"
    class="user-card"
    :class="`user-card--${cardProfile.level}`"
  >
    <div class="header">
      <p class="title">{{ cardProfile.title }}</p>
      <p class="bonus">全网权益:{{ cardProfile.bonusRange }}</p>
    </div>
    <div v-if="cardImages.length" class="card-list">
      <img
        v-for="(src, index) in cardImages"
        :key="index"
        :src="src"
        alt="卡牌"
        class="card-thumb"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchUserCardProfile } from "@/contract/services/stakeService";
import { CARD_USER_PROFILE } from "@/views/pledge/config";

export default {
  data() {
    return {
      cardProfile: null,
    };
  },
  computed: {
    ...mapGetters(["accountAddress"]),
    cardImages() {
      if (!this.cardProfile) return [];
      const { goldCards, silverCards, bronzeCards } = this.cardProfile;
      const images = [];
      for (let i = 0; i < goldCards; i += 1) {
        images.push(CARD_USER_PROFILE.gold.avatarSrc);
      }
      for (let i = 0; i < silverCards; i += 1) {
        images.push(CARD_USER_PROFILE.silver.avatarSrc);
      }
      for (let i = 0; i < bronzeCards; i += 1) {
        images.push(CARD_USER_PROFILE.bronze.avatarSrc);
      }
      return images;
    },
  },
  watch: {
    accountAddress: {
      immediate: true,
      handler() {
        this.loadCardProfile();
      },
    },
  },
  methods: {
    async loadCardProfile() {
      if (!this.accountAddress) {
        this.cardProfile = null;
        return;
      }
      try {
        this.cardProfile = await fetchUserCardProfile(this.accountAddress);
      } catch (err) {
        console.error("[UserInfoCard] 加载卡牌信息失败", err);
        this.cardProfile = null;
        throw err;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-card {
  margin: 0 30px 24px;
  padding: 20px 30px;
  border-radius: 30px;

  &--gold {
    background: #fead5b;
  }

  &--silver {
    background: #c7c7ff;
  }

  &--bronze {
    background: #f8e6c1;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;

  .title {
    margin: 0;
    font-size: 30px;
    font-weight: normal;
    color: #000000;
  }

  .bonus {
    margin: 0;
    flex-shrink: 0;
    font-size: 24px;
    color: #000000;
  }
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.card-thumb {
  display: block;
  width: 120px;
  height: auto;
  border-radius: 8px;
  object-fit: contain;
}
</style>
